import gql from 'graphql-tag';

export const CREATE_NOMINATION = gql`
  mutation ($input: CreateNominationInput!) {
    createNomination(input: $input) {
      _id
    }
  }
`;
